const $ = require("jquery");
// Reviews carousel (.reviews-block__slider) lazy-inits itself via
// data-lazy-init="slick-slider" (ui-components/slick-slider.js preset "reviews-block").
const { initReserveTallestTabPanel } = require("../../components/ui-components/askSimplyPanels");

$(function () {
    initReserveTallestTabPanel();
});
